'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  SUCCEED_GET_PARTNER_PRIVACY_LINK: null,
  FAILED_GET_PARTNER_PRIVACY_LINK: null,
  REQUEST_PARTNER_PRIVACY_LINK: null,
  DID_SHOW_PARTNER_PRIVACY: null,
  PORTAL_SELECTED: null,
  PARTNER_PROVISIONING_COMPLETED: null,
  PARTNER_PROVISIONING_FAILED: null,
  PARTNER_ID_FROM_QUERY_PARAM: null
});
module.exports = exports['default'];